import { useQuery } from '@tanstack/react-query';
import { parseCookies } from '@utils';

import { sdk } from '@/services';

const UserOnboardingService = sdk.getService('UserOnboardingService');

interface UseUserOnboardingProps {
  userId?: string;
}

export const useUserOnboarding = ({ userId }: UseUserOnboardingProps = {}) => {
  const { token } = parseCookies();

  const {
    isLoading,
    data: userOnboarding,
    refetch
  } = useQuery({
    queryKey: ['user-onboarding', userId],
    queryFn: () =>
      userId
        ? UserOnboardingService.getUserOnboardingByUserId(userId)
        : UserOnboardingService.getMyUserOnboarding(),
    enabled: !!token,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false
  });

  const isUserOnboardingCompleted =
    userOnboarding?.contract?.signatureRequestId === 'fake' ||
    (!import.meta.env.PROD && !!userOnboarding?.contract?.isContractSigned) ||
    (!!userOnboarding?.contract?.isContractSigned && !!userOnboarding?.contract?.contractFile);

  return {
    isLoading,
    userOnboarding,
    refetch,
    isUserOnboardingCompleted
  };
};
